import React, { Component } from 'react';
import withAuth from '../auth_components/js/withAuth';
import Navbar from '../Components/Navbar';
import HomeBannerAdmin from '../Components/HomeBanner/HomeBannerAdmin';


class HomeBannerContainer extends Component {
    constructor(props) {
        super(props);
        let user = JSON.parse(localStorage.getItem('user')).user;
        this.state = {
            apikey: user.apikey,
            username: user.email,
            role: user.role,
        };
    }

    render() {
        return (
            <div>
                <Navbar history={this.props.history} />
                <div className="main-body" style={{ padding: 20 }}>
                    <h2 style={{ marginBottom: 8 }}>Homepage Banner</h2>
                    <p style={{ color: '#666', marginBottom: 20 }}>
                        Manage the rotating banner images shown at the top of the home page (Recent News carousel).
                        Use the arrow buttons to reorder slides — the topmost row is the first slide.
                    </p>

                    <HomeBannerAdmin
                        apikey={this.state.apikey}
                        username={this.state.username}
                    />
                </div>
            </div>
        );
    }
}

export default withAuth(HomeBannerContainer);



// WEBPACK FOOTER //
// ./src/Containers/HomeBannerContainer.js